import React, { Component } from 'react';
import { Map, TileLayer, Marker, Pane, Tooltip, Polyline } from 'react-leaflet';
import { stopIcon } from '../../../components/leaflet/StopIcon';

export class DashboardMap extends Component {
    getBounds(mapStops) {
        let bounds = [];
        if (mapStops.length !== 0) {
            mapStops.forEach((stop) => {
                let latlng = [stop.latitude, stop.longitude];

                bounds.push(latlng);
            });
        }
        else {
            bounds = [{ lat: -90, lng: -180 }, { lat: 90, lng: 180 }];
        }

        return bounds;
    }

    renderMapPaths(mapPaths) {
        if (undefined === mapPaths || 0 === mapPaths.length) {
            return null;
        }

        return (
            <div>
                {
                    mapPaths.map((path, idx) =>
                        <div key={`polyLine-${idx}`}>
                            <Polyline positions={[path.origin, path.destination]} color={path.lineColor} />
                        </div>
                    )
                }
            </div>
        );
    }

    renderMapStops(mapStops) {
        if (undefined === mapStops || 0 === mapStops.length) {
            return null;
        }

        return (
            <div>
                {
                    mapStops.map((stop, idx) =>
                        <Marker
                            key={`marker-${idx}`}
                            position={stop.position}
                            icon={stopIcon} >
                            <Tooltip>
                                <span>{stop.name} ({stop.code})</span>
                            </Tooltip>
                        </Marker>
                    )
                }
            </div>
        );
    }

    render() {
        const { mapStops, mapPaths } = this.props;

        return (
            <Map className="map-container dashboard-map"
                zoom={13}
                scrollWheelZoom={false}
                bounds={this.getBounds(mapStops)} >
                <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Pane>
                    {this.renderMapPaths(mapPaths)}
                </Pane>
                <Pane>
                    {this.renderMapStops(mapStops)}
                </Pane>
            </Map>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/datamanager/dashboard/DashboardMap.js